export default () => {
    const items = document.querySelectorAll('[data-link]');

    if (items.length === 0) {
        return;
    }

    items.forEach((item) => {
        const link = item.querySelector('a[href]');

        if (!link) {
            return;
        }

        item.addEventListener('click', () => {
            link.click();
        });
    });
};
